import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { menu } from '../../../constants';
import SignupForm from './SignupForm/SignupForm';
import VerificationForm from './VerificationForm/VerificationForm';
import { successMessages, errorMessages } from '../../../utils/messagesUtils';

const Signup = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState('registration');
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // サインアップフォーム送信処理
    const handleSignupSubmit = async (data) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/signup`,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                    credentials: 'include',
                }
            );
            
            const result = await response.json();
            if (result.status === 'OK' && response.status === 200) {
                setEmail(data.email);
                setCurrentStep('verification');
            }else{
                setErrorMessage(errorMessages.signup.send_code_failed);
            }
        } catch (e) {
            Swal.fire({icon: 'error',
                html: errorMessages.api.server_error,
                customClass: {
                    htmlContainer: 'large-text'
                }
            });
        }
    };

    // 認証コード送信処理
    const handleVerificationSubmit = async (data, setMessage) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signup/authentication`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
                credentials: 'include'
            });
            const result = await response.json();
            if (result.status === 'OK' && response.status === 200) {
                setMessage(<p className="account-success-msg">{successMessages.signup.completed}</p>);
                setTimeout(() => {
                    navigate(menu.ENGINEER.SIGNIN.PATH);
                }, 1000);
            } else {
                if (response.status === 401) {
                    // 認証コードが間違っている
                    setMessage(<p className="account-error-msg">{errorMessages.signup.authentication_failed}</p>);
                }else{
                    // それ以外のエラー
                    setMessage(<p className="account-error-msg">{errorMessages.signup.failed}</p>);
                }
            }
        } catch (e) {
            Swal.fire({icon: 'error',
                html: errorMessages.api.server_error,
                customClass: {
                    htmlContainer: 'large-text'
                }
            });
        }
    };

    // 認証コード再送信処理
    const handleResend = async (email, setMessage) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/signup/resend`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email }),
                credentials: 'include'
            });
            
            const result = await response.json();
            if (result.status === 'OK' && response.status === 200) {
                setMessage(<p className="account-success-msg">{successMessages.signup.resend}</p>);
                setTimeout(() => {
                    setMessage(null);
                }, 2000);
            } else {
                if (response.status === 404) {
                    // メールアドレスが見つからない
                    setMessage(<p className="account-error-msg">{errorMessages.signup.resend_failed_email_not_found}</p>);
                }else{
                    // それ以外のエラー
                    setMessage(<p className="account-error-msg">{errorMessages.signup.send_code_failed}</p>);
                }
            }
        } catch (e) {
            Swal.fire({icon: 'error',
                html: errorMessages.api.server_error,
                customClass: {
                    htmlContainer: 'large-text'
                }
            });
        }
    };

    return (
        <form className="bg">
            <div className="account-container">
                {currentStep === 'registration' ? (
                    <SignupForm 
                        onSubmit={handleSignupSubmit} 
                        errorMessage={errorMessage} 
                    />
                ) : (
                    <VerificationForm 
                        email={email}
                        onSubmit={handleVerificationSubmit}
                        onResend={handleResend}
                    />
                )}
            </div>
        </form>
    );
};

export default Signup;